// Component for showing the status of the returning order

import React from 'react'
import styled from 'styled-components'
import SpeedIcon from '../../../../../generic/icons/IconLib/TruckIcon'
import { getDriverStatusColor, getTextFromDriverStatus } from '../../teudotProblems/hooks/useProblemHelpers'

interface IProps {
  status: number
  onClick?: (e: React.MouseEvent) => void
}

const StatusReturningBadge = ({ status, onClick }: IProps) => {

    const color = getDriverStatusColor(status)
    const text = getTextFromDriverStatus(status)
  return (
    <DriverStatusBadge $color={color} $clickable={!!onClick} onClick={onClick}>
        <SpeedIcon color={'#fff'} /> {text}
    </DriverStatusBadge>
  )
}
const DriverStatusBadge = styled.div<{$color?: string, $clickable?: boolean}>`
    background: ${props => props.$color ? props.$color : '#7ab0ab'};
    color: #fff;
    padding: 0.2em 0.5em;
    border-radius: 10px;
    cursor: ${props => props.$clickable ? 'pointer' : 'default'};
`
export default StatusReturningBadge